import { ImageGallery } from "@features/image-gallery/ui/ImageGallery";
import { type DailyLogImageController, MAX_IMAGES } from "@features/write-daily-log/model/useDailyLogImageController";

interface SitePictureStepProps {
  controller: DailyLogImageController;
}

/**
 * 일일 로그 사진 업로드 스텝.
 *
 * 업로드/후처리/순서/폼 동기화는 상위 funnel 이 소유한 controller 가 담당하고,
 * 이 컴포넌트는 controller 출력으로 {@link ImageGallery} 를 렌더하기만 한다.
 */
export function SitePictureStep({ controller }: SitePictureStepProps) {
  const { items, addFiles, removeItem, retryItem, releaseLocalPreview, isAtMax } = controller;

  return (
    <ImageGallery
      items={items}
      isAtMax={isAtMax}
      maxImages={MAX_IMAGES}
      onAddFiles={addFiles}
      onRemove={removeItem}
      onRetry={retryItem}
      onLocalPreviewReady={releaseLocalPreview}
    />
  );
}
